import initialState from './initialState'

const FETCH_MESSAGE = 'md/features/Pressroom/pages/PressMessage/FETCH_MESSAGES'
const FETCH_MESSAGE_SUCCESS = 'md/features/Pressroom/pages/PressMessage/FETCH_MESSAGES_SUCCESS'
const FETCH_MESSAGE_FAILED = 'md/features/Pressroom/pages/PressMessage/FETCH_MESSAGES_FAILED'

export const fetchMessage = (id, laguagecode) => {
  const payload = {
    id: id,
    languageCode: laguagecode
  }
  return {
    types: [FETCH_MESSAGE, FETCH_MESSAGE_SUCCESS, FETCH_MESSAGE_FAILED],
    callApi: {
      endpoint: 'api/pressroommessage/',
      method: 'GET',
      data: payload
    }
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MESSAGE:
      return {
        ...state,
        loading: true,
        item: null
      }
    case FETCH_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.data
      }
    case FETCH_MESSAGE_FAILED:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}